import script from "./HtmlHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlHeader.vue?vue&type=script&setup=true&lang=js"

import "./HtmlHeader.vue?vue&type=style&index=0&id=6dab7fbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dab7fbe"]])

export default __exports__